<!--
  AI:
  Status: "in progress"
  Type: Page
  SubType: CreatePage
  Reason: [CO-APP R3/A] Kundenanlage of the Co-App - ONLY the customer create wizard, in full width. No
  „Kunden angelegt in den letzten 7 Tagen" widget: that list is tenant-wide (data protection).
-->
@if (initialized) {

    <div class="flex flex-column gap-2">

        <!--
          [CO-APP R3/A] The assignment to the logged-on agent failed. Shown HERE, before navigating, so
          „Erneut versuchen" stays reachable - a toast action would be gone after the navigation.
        -->
        @if (pendingAssignmentCustomerId) {
            <p-message severity="warn" styleClass="w-full">
                <div class="flex align-items-center justify-content-between gap-3 flex-wrap w-full">
                    <span>Der Kunde wurde angelegt, die Zuordnung zu Ihnen ist fehlgeschlagen.</span>
                    <div class="flex align-items-center gap-2">
                        <p-button label="Erneut versuchen"
                                  icon="fa-regular fa-rotate-right"
                                  size="small"
                                  [loading]="requestRunning"
                                  [disabled]="requestRunning"
                                  (onClick)="handleRetryAssignment()">
                        </p-button>
                        <p-button label="Kunde trotzdem öffnen"
                                  icon="fa-regular fa-arrow-right"
                                  size="small"
                                  severity="secondary"
                                  [outlined]="true"
                                  [disabled]="requestRunning"
                                  (onClick)="handleOpenCustomerWithoutAssignment()">
                        </p-button>
                    </div>
                </div>
            </p-message>
        } @else if (requestRunning) {
            <!-- [CO-APP R3/A] a finished run is being answered: assignment / access check, then navigation -->
            <div class="flex align-items-center gap-2 text-600">
                <i class="fa-regular fa-spinner fa-spin"></i>
                <span>Kunde wird geöffnet …</span>
            </div>
        }

        <!--
          ⚠ [spec] binds a FIELD, never an object literal or a getter (TRAP 3, see CrCustomerCreatePage):
          a fresh identity on this input rebuilds the wizard's embedded forms and discards the user's input.
          NO mount guard around the wizard - it starts its run when it is created.
        -->
        <ci-customer-create-wizard
                [spec]="customerCreateWizardSpec"
                [emptyStepNote]="customerCreateEmptyStepNote"
                (onWizardFinished)="handleCustomerCreateFinished($event)">
        </ci-customer-create-wizard>

    </div>

}
